class VideoEvent {

	// state changes

	get LOADING_SUCCESS() { return 'video-event__loading-success'; }
	get LOADING_ERROR() { return 'video-event__loading-error'; }
	get LOADING_META_DATA() { return 'video-event__loading-meta-data'; }

	get PAUSING() { return 'video-event__pausing'; }
	get PLAYING() { return 'video-event__playing'; }
	get PLAYING_COMPLETE() { return 'video-event__playing-complete'; }
	get PLAYING_STATUS() { return 'video-event__playing-status'; }
	get PROGRESS() { return 'video-event__progress'; }
	get REPLAYING() { return 'video-event__replaying'; }
	get SEEKING() { return 'video-event__seeking'; }

	get MUTING() { return 'video-event__muting'; }
	get UNMUTING() { return 'video-event__unmuting'; }

	get RELOADING() { return 'video-event__reloading'; }
	get UNLOADING() { return 'video-event__unloading'; }

	get STATUS() { return 'video-event__status'; }

	// commands

	get PAUSE() { return 'video-event__pause'; }
	get PLAY() { return 'video-event__play'; }
	get REPLAY() { return 'video-event__replay'; }
	get SEEK() { return 'video-event__seek'; }
	get MUTE() { return 'video-event__mute'; }
	get UNMUTE() { return 'video-event__unmute'; }

	get LOAD() { return 'video-event__load'; }
	get RELOAD() { return 'video-event__reload'; }
	get UNLOAD() { return 'video-event__unload'; }

	get STATUS_QUERY() { return 'video-event__status-query'; }

}

export default new VideoEvent();
